import {ChangeDetectionStrategy, Component, computed, inject, output} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

import {AuthenticationService} from 'src/app/services/auth/authentication.service';
import {CurrentTenantStore} from 'src/app/services/tenant/current-tenant.store';
import {LOGIN_URL, SETTINGS_ACCOUNT_URL} from 'src/app/models/home/navigation.model';
import {DisplayUserLogoComponent} from 'src/app/modules/design-system/display-user-logo/display-user-logo.component';

/**
 * Contenu du dropdown profil (identité + « Mon compte » + « Se déconnecter »),
 * partagé entre la rangée utilisateur du menu principal et l'avatar du header
 * téléphone. L'hôte fournit le `<app-dropdown>` (position) et le ferme sur `closed`.
 */
@Component({
	selector: 'app-user-menu-card',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslateModule, DisplayUserLogoComponent],
	templateUrl: './user-menu-card.component.html',
	styleUrl: './user-menu-card.component.scss'
})
export class UserMenuCardComponent {

	readonly closed = output<void>();

	private router = inject(Router);
	private authenticationService = inject(AuthenticationService);

	protected readonly tenantAccount = inject(CurrentTenantStore).currentAccount;

	protected readonly fullName = computed(() => {
		const account = this.tenantAccount()?.account;
		return account ? `${account.firstName ?? ''} ${account.lastName ?? ''}`.trim() : '';
	});

	protected readonly email = computed(() => this.tenantAccount()?.account?.email ?? '');

	goToAccountSettings(): void {
		this.router.navigate([SETTINGS_ACCOUNT_URL], {queryParamsHandling: 'preserve'});
		this.closed.emit();
	}

	logout(): void {
		this.authenticationService.logout();
		this.router.navigate([LOGIN_URL]);
		this.closed.emit();
	}
}
